import { Box, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { Column } from "../../misc/Column";
import { Row } from "../../misc/Row";
import { useThemeColor } from "../../hooks/useThemeColor";

export function LessonProgressTimeline(props: { event: { start: DateTime; end: DateTime } }) {
  const { event } = props;
  const theme = useTheme();
  const primaryColor = useThemeColor("primary");
  const now = DateTime.now().setZone("Europe/Berlin");
  const activeStepIndex = now < event.start ? 0 : now < event.end ? 1 : 2;
  const steps = ["Geplant", "Unterricht", "Beendet"] as const;

  return (
    <Row
      sx={{
        height: { xs: "auto", sm: "55px" },
        width: "100%",
        boxSizing: "border-box",
        border: 1,
        borderColor: "divider",
        borderRadius: "12px",
        alignItems: "center",
        overflow: "hidden",
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      {steps.map((title, index) => {
        const isActiveStep = index === activeStepIndex;
        const durationInMinutes = Math.max(0, Math.round(event.end.diff(event.start, "minutes").minutes));
        const subtitle =
          index === 0
            ? `${event.start.setZone("Europe/Berlin").toFormat("HH:mm")} - ${event.end.setZone("Europe/Berlin").toFormat("HH:mm")} Uhr`
            : index === 1
              ? `${durationInMinutes} Minuten`
              : `${event.end.setZone("Europe/Berlin").toFormat("HH:mm")} Uhr`;

        const backgroundColor = isActiveStep ? primaryColor.main : theme.palette.background.paper;
        const titleColor = isActiveStep ? theme.palette.common.white : theme.palette.text.disabled;
        const subtitleColor = isActiveStep ? theme.palette.common.white : theme.palette.text.disabled;

        return (
          <Row
            key={title}
            sx={{
              flex: { xs: "none", sm: 1 },
              width: { xs: "100%", sm: "auto" },
              height: { xs: "48px", sm: "100%" },
              alignItems: "center",
              backgroundColor,
            }}
          >
            {index > 0 && (
              <Box sx={{ display: { xs: "none", sm: "flex" } }}>
                <TimelineTriangleDivider arrowColor={backgroundColor} borderColor={theme.palette.divider} />
              </Box>
            )}
            <Column sx={{ flex: 1, alignItems: "center" }}>
              <span style={{ fontSize: "16px", fontWeight: 600, color: titleColor }}>{title}</span>
              <span style={{ fontSize: "12px", fontWeight: 500, color: subtitleColor }}>{subtitle}</span>
            </Column>
          </Row>
        );
      })}
    </Row>
  );
}

function TimelineTriangleDivider(props: { arrowColor: string; borderColor: string }) {
  const { arrowColor, borderColor } = props;

  return (
    <Column sx={{ marginLeft: "-20px", border: 0, outline: 0 }}>
      <Row
        sx={{
          height: "56px",
          width: "20px",
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 18px 50%)",
          backgroundColor: borderColor,
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            height: "56px",
            width: "18px",
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 100% 50%)",
            backgroundColor: arrowColor,
          }}
        />
      </Row>
    </Column>
  );
}
